import { useLazyQuery } from "@apollo/client"
import { Intent } from "@blueprintjs/core"
import { get } from "lodash-es"
import React, { useMemo, useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import CustomSpinner from "components/Atoms/CustomSpinner"
import StringInput from "components/Atoms/StringInput"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import FormController from "components/Molecules/FormController"
import MutationOptions from "components/Organisms/MutationOptions"
import AppToaster from "utils/AppToaster"
import {
  ADD_UPDATE_GROUP,
  GROUP_DETAILS,
  GROUP_LIST,
} from "graphql/group.graphql.gql"
import { PERMISSIONS } from "graphql/selector.queries.gql"
import { updateList } from "utils/apollo.utils"
import { getId } from "utils/custom.utils"
import { graphqlError } from "utils/parseError"
export default function GroupRegistration({ isOpen, onClose, id: groupId }) {
  const [groupDetails, changeGroup] = useState({
    name: "",
    permissions: [],
  })

  const parsedVariables = useMemo(() => {
    return {
      id: getId(groupDetails),
      permissions:
        groupDetails.permissions && groupDetails.permissions.map(g => getId(g)),
      name: groupDetails.name,
    }
  }, [groupDetails])
  const [getGroupData, { loading, error }] = useLazyQuery(GROUP_DETAILS, {
    onCompleted({ groupDetails }) {
      changeGroup(groupDetails)
    },
  })

  if (loading) return <CustomSpinner />
  if (error) return <>{error.message}</>

  function showToast(data) {
    const group = get(data, "addGroup.group")

    return AppToaster.show({
      message: `Group ${group.name} ${
        groupId ? "Edited" : "Added"
      } successfully.`,
      intent: Intent.SUCCESS,
    })
  }

  function handleChange(path, value) {
    changeGroup(prevGroup => ({
      ...prevGroup,
      [path]: value,
    }))
  }

  return (
    <CustomDialog
      light
      icon="people"
      title="Register Group"
      isOpen={isOpen}
      onClose={onClose}
      onOpened={e => {
        if (groupId && parseInt(groupId))
          getGroupData({ variables: { id: groupId } })
      }}
    >
      <FormController source={groupDetails} onChange={handleChange}>
        <div id="group-registration">
          <StringInput
            helperText="Unique group name for grouping permissions."
            label="Group Name"
            path="name"
          ></StringInput>

          <DynamicMultiSelector
            fill
            formGroupProps={{
              className: "mt-6",
            }}
            label="Available Permissions"
            helperText="Add permissions for the above group."
            big={true}
            path="permissions"
            query={PERMISSIONS}
          ></DynamicMultiSelector>
        </div>
      </FormController>
      <hr />
      <MutationOptions
        mutation={ADD_UPDATE_GROUP}
        variables={parsedVariables}
        update={(cache, result) => {
          const addedGroup = get(result, "data.addGroup.group")
          updateList({ cache, query: GROUP_LIST, newItem: addedGroup })
        }}
        onError={err => {
          AppToaster.show({
            message: graphqlError(err.message),
            intent: Intent.DANGER,
          })
        }}
        onSave={data => {
          showToast(data)
          onClose()
        }}
        onSaveAndEdit={showToast}
        onSaveAndAdd={data => {
          showToast(data)
          changeGroup({ name: "", permissions: [] })
        }}
      ></MutationOptions>
    </CustomDialog>
  )
}
